import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  travels: []
}

const mutations = {  
  SET_TRAVELS (state, payload) {
    state.travels = payload
  }  
}

const actions = {
  travelList: (context, data) => {
    let query = '?'
    if (Array.isArray(data.ids)) {
      for (let element of data.ids) {                 
        query += `&_id[]=${element}`
      }
    }
    return Vue.http.get(`${env.API}/api/travel${query}`)    
      .then((response) => {        
        context.commit('SET_TRAVELS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  travelListByIds: (context, data) => {
    return Vue.http.get(`${env.API}/api/travel/listByIds${data.travelIds}`)
      .then((response) => {
        context.commit('SET_TRAVELS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getTravelById: (context, id) => {
    if (id == undefined) {
      return null
    } else {
      return Vue.http.get(`${env.API}/api/travel/by-id/${id}`)    
        .then((response) => {                
          return response.body.message
        })
        .catch((error) => {
          return context.commit('API_FAILURE', error)
        })
    }
  },
  getTravelsByRoles: (context, ids) => {
    return Vue.http.post(`${env.API}/api/travel/by-roles`, ids)    
      .then((response) => {
        context.commit('SET_TRAVELS', response.body.message)              
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getTravels: (state) => state.travels
}

export const travel = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/travel.js